import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { formBtn1, formBtn3 } from "../Utils/CustomClasses";
import { useForm } from "react-hook-form";
import CrossLogo from '../../assets/Images/crossimage.png'
import { DeleteCompanyAPI, GetAllCompanyAPI } from '../../API/Api';
import { toast } from 'react-toastify';

export default function ViewCompanyModal({ DeleteModal, setDeleteModal, row, filterRecords }) {
    const { reset, formState: { errors } } = useForm();
    const toggle = () => {
        setDeleteModal(false);
        reset();
    };

    const onDelete = (row) => {
        DeleteCompanyAPI(row._id)
            .then(res => {
                if (res?.status === 200) {
                    filterRecords()
                    toast.success(res?.data?.message);
                    toggle();
                } else {
                    toggle();
                    toast.error(res?.data?.message)
                }
            })
            .catch((err) => {
                console.log('Error:', err);
                toast.error(err);
            });
    };


    return (
        <>
            <Transition appear show={DeleteModal} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        Delete Company
                                    </Dialog.Title>
                                    <div className="p-4">
                                        {/* content inside the delete modal */}
                                        <div className="flex items-center justify-center flex-col">
                                            <div>
                                                <img src={CrossLogo} className='w-[65px] h-[65px]' />
                                            </div>
                                            <div>
                                                <h4 className='text-black base-font-inter font-bold pt-2 capitalize w-[300px] text-center'>Are you sure ?</h4>
                                            </div>
                                            <div>
                                                <h6>Do you really want to delete this record. This process cannot be undone</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                        <button
                                            type="button"
                                            className={`${formBtn1} px-4 py-2 text-white font-bold rounded-lg`}
                                            onClick={toggle}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => onDelete(row)}
                                            className={`${formBtn3} px-4 py-2 text-white font-bold rounded-lg`}
                                        >
                                            Delete
                                        </button>
                                    </footer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
